<template>

  <section class="table-wrapper">

    <div
        v-if="rows.length > 0"
        class="table-scroll"
    >
      <table v-if="rows.length>0">

        <thead>

        <tr>

          <th>جایگاه</th>
          <th class="team-column">تیم</th>
          <th>بازی</th>
          <th class="col-wdl">برد</th>
          <th class="col-wdl">مساوی</th>
          <th class="col-wdl">بـاخت</th>
          <th>تفاضل</th>
          <th>امتیاز</th>

        </tr>

        </thead>

        <tbody>

        <tr
            v-for="row in rows"
            :key="row.position"
            :class="rowClass(row.position)"
        >

          <td>

            {{ row.position }}

          </td>

          <td
              class="team-column"
              @click="row.slug && $router.push(`/team/${row.slug}`)"
          >

            <img
                :src="row.logo"
                :alt="row.name"
            >

            <span>

            {{ getTeamName(row.name) || 'نامشخص'}}
          </span>

          </td>

          <td>{{ row.played }}</td>

          <td class="col-wdl">{{ row.won }}</td>

          <td class="col-wdl">{{ row.draw }}</td>

          <td class="col-wdl">{{ row.lost }}</td>

          <td>

            {{ row.goalDifference }}

          </td>

          <td class="points">

            {{ row.points }}

          </td>

        </tr>

        </tbody>

      </table>
    </div>
    <div v-else class="empty-state">
      ⚽ داده‌ای برای این لیگ و فصل موجود نیست
    </div>
  </section>

</template>

<script>
import { teamNameFa } from '@/utils/translations';


export default {

  name: 'CompetitionTable',

  data() {
    return {
      columnTranslations: {
        position: 'رتبه',
        team: 'تیم',
        played: 'بازی',
        won: 'برد',
        draw: 'مساوی',
        lost: 'باخت',
        goalsFor: 'گل زده',
        goalsAgainst: 'گل خورده',
        goalDifference: 'تفاضل',
        points: 'امتیاز'
      }
    }
  },
  props: {

    rows: {

      type: Array,

      default: () => []

    }

  },

  methods: {

    rowClass(position) {

      if (position <= 4) return 'ucl'

      if (position <= 6) return 'uel'

      if (position >= 18) return 'relegation'

      return ''

    },
    // در متد یا computed:
    getTeamName(englishName) {
      return teamNameFa(englishName) || 'نامشخص';
    }

  }

}

</script>

<style lang="scss" scoped>

.table-wrapper {
  width: 100%;
  background: #fff;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(0, 0, 0, .05);
}

.table-scroll {
  width: 100%;

  overflow-x: auto;
  overflow-y: hidden;

  -webkit-overflow-scrolling: touch;
}

table {
  width: 100%;
  border-collapse: collapse;
  min-width: 650px;
}

thead {

  background: #0f172a;

  color: #fff;

}

th {

  padding: 15px 10px;
  white-space: nowrap;
  font-weight: 600;

}

td {

  padding: 10px 5px;

  border-bottom: 1px solid #eee;
  white-space: nowrap;
  text-align: center;

}

tbody tr {

  transition: .2s;

  td {
    &:first-child {
      width: 20px;
    }
  }

}

tbody tr:hover {

  background: #f8fafc;

}

.team-column {
  width: 220px;
  min-width: 220px;
  max-width: 220px;

  position: relative;
  box-sizing: border-box;

  text-align: right;
  white-space: nowrap;
  overflow: hidden;

  cursor: pointer;

  &:hover span {
    color: #2563eb;
    text-decoration: underline;
  }
}

.team-column img {
  width: 20px;
  height: 20px;
  object-fit: contain;
  vertical-align: middle;
  margin-left: 12px;
}

.team-column span {
  color: gray;
  font-weight: 600;

  vertical-align: middle;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.points {

  font-weight: bold;

  color: #2563eb;

}

tbody tr.ucl .team-column {
  border-right: 5px solid #22c55e;
}

tbody tr.uel .team-column {
  border-right: 5px solid #f59e0b;
}

tbody tr.relegation .team-column {
  border-right: 5px solid #ef4444;
}


@media (max-width: 768px) {

  table {
    font-size: 12px;
    min-width: 0; /* جدول جمع‌وجور — بدون اسکرول افقی */
    table-layout: auto;
  }

  /* ستون‌های برد/مساوی/باخت در موبایل حذف — خلاصه: رتبه، تیم، بازی، تفاضل، امتیاز */
  .col-wdl {
    display: none;
  }

  th,
  td {
    padding: 8px 4px;
  }

  /* ستون تیم فضای باقی‌مانده را می‌گیرد */
  .team-column {
    width: auto;
    min-width: 0;
    max-width: 160px;
  }

  .team-column img {
    width: 22px;
    height: 22px;
    margin-left: 6px;
  }

  .team-column span {

    max-width: 110px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  /* ستون‌های عددی باریک‌تر */
  th:not(.team-column),
  td:not(.team-column) {
    padding-left: 3px;
    padding-right: 3px;
  }

}

</style>